import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownText = ({ children }) => {
  if (!children) return null;

  return (
    <ReactMarkdown
      components={{
        h1: ({ children }) => <h1 className="text-2xl font-bold text-foreground mt-4 mb-2">{children}</h1>,
        h2: ({ children }) => <h2 className="text-xl font-bold text-foreground mt-4 mb-2">{children}</h2>,
        h3: ({ children }) => <h3 className="text-lg font-semibold text-foreground mt-3 mb-1">{children}</h3>,
        h4: ({ children }) => <h4 className="text-base font-semibold text-foreground mt-2 mb-1">{children}</h4>,
        p: ({ children }) => <p className="text-foreground leading-relaxed mb-2">{children}</p>,
        strong: ({ children }) => <strong className="font-semibold text-foreground">{children}</strong>,
        em: ({ children }) => <em className="italic text-muted-foreground">{children}</em>,
        ul: ({ children }) => <ul className="list-disc list-inside space-y-1 mb-3 text-foreground">{children}</ul>,
        ol: ({ children }) => <ol className="list-decimal list-inside space-y-1 mb-3 text-foreground">{children}</ol>,
        li: ({ children }) => <li className="text-foreground">{children}</li>,
        hr: () => <hr className="border-border my-4" />,
        blockquote: ({ children }) => (
          <blockquote className="border-l-4 border-primary/30 pl-4 italic text-muted-foreground my-2">
            {children}
          </blockquote>
        ),
        code: ({ inline, children }) =>
          inline
            ? <code className="bg-muted px-1.5 py-0.5 rounded text-sm font-mono">{children}</code>
            : <pre className="bg-muted p-3 rounded-lg overflow-x-auto text-sm font-mono my-2"><code>{children}</code></pre>,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default MarkdownText;
